import * as Yup from "yup";

export const LessonSchema = Yup.object().shape({
  title: Yup.string().required("موضوع الزامی می باشد"),
  grade: Yup.number().required("وارد کردن پایه تحصیلی الزامی می باشد"),
  book: Yup.string().required("وارد کردن نام کتاب الزامی می باشد"),
  lesson: Yup.string().required("وارد کرده شماره درس الزامی می باشد"),
});
